/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_DismissInputs */

const en_ui_dismiss = /** @type {(inputs: Ui_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const ar_ui_dismiss = en_ui_dismiss;

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const he_ui_dismiss = en_ui_dismiss;

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const ur_ui_dismiss = en_ui_dismiss;

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const es_ui_dismiss = en_ui_dismiss;

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const fr_ui_dismiss = en_ui_dismiss;

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const de_ui_dismiss = en_ui_dismiss;

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const pt_ui_dismiss = en_ui_dismiss;

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const hi_ui_dismiss = en_ui_dismiss;

/** @type {(inputs: Ui_DismissInputs) => LocalizedString} */
const bn_ui_dismiss = en_ui_dismiss;

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Ui_DismissInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_dismiss = /** @type {((inputs?: Ui_DismissInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_DismissInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_dismiss(inputs)
	if (locale === "he") return he_ui_dismiss(inputs)
	if (locale === "ur") return ur_ui_dismiss(inputs)
	if (locale === "es") return es_ui_dismiss(inputs)
	if (locale === "fr") return fr_ui_dismiss(inputs)
	if (locale === "de") return de_ui_dismiss(inputs)
	if (locale === "pt") return pt_ui_dismiss(inputs)
	if (locale === "hi") return hi_ui_dismiss(inputs)
	if (locale === "bn") return bn_ui_dismiss(inputs)
	return /** @type {LocalizedString} */ ("Dismiss")
});